"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PageFourForcedContent;
var _react = _interopRequireDefault(require("react"));
var _Column = _interopRequireDefault(require("../svg/Column"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function PageFourForcedContent() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: ""
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-block"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement(_Column.default, {
    className: "align-top"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-block rig-sideContent-title"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: " mm-spacing--minor"
  }, "Get 170+ years of experience by your side"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }, "We have over 7,500 financial professionals who can help you with insurance, investing, retirement, planning and so much more.", /*#__PURE__*/_react.default.createElement("p", null), "We're here to help prepare for just about anything the future has in store.", ' ', /*#__PURE__*/_react.default.createElement("p", null))));
}